import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import FilePlaceholder from '../../../../../shared/components/placeholder/FilePlaceholder';
import { downloadFile, linkify } from '../../../../../shared/functions/Functions';
import DOMPurify from 'dompurify';
import { IFeedbackData } from './summary/components/CampaignFeedback';
import { useTranslation } from 'react-i18next';
import ToggleSwitch from '../../../../../shared/components/ToggleSwitch';
import ItemKPI from './kpis/components/ItemKPI';
import { IKPI } from '../../../../../model/measure/IMeasure';

interface CampaignClientPreviewProps {
    feedbackData?: IFeedbackData;
    additionalKpi?: IKPI[];
}

const CampaignClientPreview = ({ feedbackData, additionalKpi }: CampaignClientPreviewProps) => {
    const { t } = useTranslation();
    const hasCampaignFeedback = !!feedbackData?.teamFeedback || !!feedbackData?.feedbackFile?.length;
    const hasKpis = additionalKpi?.length && !!additionalKpi[0]?.title;
    const [switchView, setSwitchView] = useState(!hasCampaignFeedback);

    return (
        <Row>
            {(hasCampaignFeedback || hasKpis) && (
                <>
                    {!!feedbackData?.feedbackFile?.length && (
                        <Col xl={2} md={3} className="position-relative">
                            <FilePlaceholder
                                file={feedbackData?.feedbackFile?.[0]}
                                classContent="py-4"
                                classIcon="font-120"
                                nameFancybox="measure-feedback-gallery"
                                handleDownload={() =>
                                    downloadFile(
                                        feedbackData?.feedbackFile?.[0]?.path ?? '/icons/filePlaceholder.png',
                                        feedbackData?.feedbackFile?.[0]?.originalName
                                    )
                                }
                            />
                        </Col>
                    )}
                    <Col xl={10} md={9} className={`${!feedbackData?.feedbackFile?.length && ''}`}>
                        <div className="mb-3">
                            <h4 className="mb-3">{t('brand.campaign.measure.campaignFeedback')}</h4>
                            <div className="d-flex justify-content-start align-items-center">
                                {hasCampaignFeedback && (
                                    <h6 className={`mb-0 mr-2 ${!switchView ? 'text-primary' : 'text-muted'}`}>
                                        {feedbackData?.company?.displayName ?? 'Agency partner'} Feedback
                                    </h6>
                                )}
                                {hasCampaignFeedback && hasKpis && (
                                    <ToggleSwitch
                                        id="switch-view"
                                        checked={switchView}
                                        small={true}
                                        onChange={(checked: boolean) => setSwitchView(checked)}
                                    />
                                )}
                                {hasKpis && (
                                    <h6
                                        className={`mb-0 ${hasCampaignFeedback && hasKpis && 'ml-2'} ${
                                            switchView ? 'text-primary' : 'text-muted'
                                        }`}
                                    >
                                        Agency defined KPIs
                                    </h6>
                                )}
                            </div>
                        </div>
                        {switchView ? (
                            <Row className="mt-2" style={{ gap: '32px' }}>
                                {hasKpis &&
                                    additionalKpi?.map((kpi, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <ItemKPI {...kpi} />
                                            </React.Fragment>
                                        );
                                    })}
                            </Row>
                        ) : (
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(linkify(feedbackData?.teamFeedback ?? '-')),
                                }}
                            ></p>
                        )}
                    </Col>
                </>
            )}
        </Row>
    );
};

export default CampaignClientPreview;
